import { OrdersTable } from './OrdersTable'
import { OrdersTab } from './OrderTab'

export const Order = {
  Tab: OrdersTab,
  Table: OrdersTable,
}
